export { GrpcClientService } from './grpc-client.service';
export { GrpcRegistryService } from './grpc-registry.service';
export { GrpcProviderService } from './grpc-provider.service';
export { GrpcProtoService } from './grpc-proto.service';
export { GrpcControllerDiscoveryService } from './grpc-controller-discovery.service';

// Alias for backward compatibility
export { GrpcProtoService as ProtoLoaderService } from './grpc-proto.service';
